import Vue from 'vue'
import Router from 'vue-router'
import Layout from './views/Layout.vue'
import store from './store/index'
import axios from './plugins/axios'
Vue.use(Router)

// lazy-loaded
function loadView(path) {
  return () => import(/* webpackChunkName: "view-[request]" */ `${path}`)
}

const router = new Router({
  mode: process.env.NODE_ENV === 'development' ? 'hash' : 'history',
  base: process.env.VUE_APP_BASE,
  routes: [
    {
      path: '/',
      component: Layout,
      children: [
        {
          path: '/',
          name: 'home',
          component: loadView('./views/Home/index.vue'),
        },
        {
          path: 'upload',
          name: 'upload',
          component: loadView('./views/Upload/index.vue'),
        },
        {
          path: 'watch',
          name: 'watch',
          component: loadView('./views/Watch/index.vue'),
        },
        {
          path: 'rules',
          name: 'rules',
          component: loadView('./views/Rules/index.vue'),
          meta: { hideButton: true },
        },
        {
          path: 'privacy_policy',
          name: 'PrivacyPolicy',
          component: loadView('./views/PrivacyPolicy/index.vue'),
          meta: { hideButton: true },
        },
        {
          path: 'terms_of_service',
          name: 'TermsOfService',
          component: loadView('./views/TermsOfService/index.vue'),
          meta: { hideButton: true },
        },
        {
          path: '404',
          name: 'NotFound',
          component: loadView('./views/404/index.vue'),
        },
        {
          path: '*',
          redirect: '/404',
        },
      ],
    },
  ],
})

router.beforeEach(async (to, from, next) => {
  // store.commit('LoginMask/SET_MASK_ACTIVE', false)

  // axios.post('/analytics/page-view', {
  //   page: 'contest',
  // })

  // await store.dispatch('Config/getConfig')
  // if (
  //   to.name === 'upload' &&
  //   !store.state.Config.ART_SUBMIT_ENABLE &&
  //   !store.state.Config.COS_SUBMIT_ENABLE &&
  //   !store.state.Config.LCOS_SUBMIT_ENABLE
  // ) {
  //   next('/404')
  // } else {
  //   next()
  // }

  // next()

  store.commit('LoginMask/SET_MASK_ACTIVE', false)

  axios.post('/analytics/page-view', {
    page: 'contest',
  })

  await store.dispatch('Config/getConfig')

  if (
    to.name === 'upload' &&
    !store.state.Config.ART_SUBMIT_ENABLE &&
    !store.state.Config.COS_SUBMIT_ENABLE &&
    !store.state.Config.LCOS_SUBMIT_ENABLE
  ) {
    next('/404')
  } else {
    next()
  }
})

export default router
